import pythonApiClient from './pythonBaseApi';

const baseUrl = '/rrhh/remuneraciones';

const remuneracionesApi = {
  /**
   * Obtiene la remuneración activa actual de un empleado
   */
  getActiva: async (empleadoId) => {
    try {
      const res = await pythonApiClient.get(`${baseUrl}/${empleadoId}/activa`);
      return res.data;
    } catch (error) {
      console.error(`Error obteniendo remuneración activa para empleado ${empleadoId}:`, error);
      throw error;
    }
  },

  /**
   * Obtiene el historial completo de remuneraciones de un empleado
   */
  getHistorial: async (empleadoId) => {
    try {
      const res = await pythonApiClient.get(`${baseUrl}/${empleadoId}/historial`);
      return res.data;
    } catch (error) {
      console.error(`Error obteniendo historial de remuneraciones para empleado ${empleadoId}:`, error);
      throw error;
    }
  },

  /**
   * Crea una nueva remuneración (y desactiva la anterior)
   */
  crearRemuneracion: async (remuneracionData) => {
    try {
      const res = await pythonApiClient.post(`${baseUrl}/`, remuneracionData);
      return res.data;
    } catch (error) {
      console.error('Error creando remuneración:', error);
      throw error;
    }
  },

  /**
   * Sube un archivo de sustento
   */
  uploadSustento: async (empleadoId, file) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      
      const res = await pythonApiClient.post(
        `${baseUrl}/${empleadoId}/upload-sustento`, 
        formData, 
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      return res.data;
    } catch (error) {
      console.error('Error subiendo sustento:', error);
      throw error;
    }
  },

  /**
   * Obtiene la lista de empleados que no tienen remuneración en un proyecto
   */
  getEmpleadosSinRemuneracion: async (proyectoId) => {
    try {
      const res = await pythonApiClient.get(`${baseUrl}/sin-asignar/proyecto/${proyectoId}`);
      return res.data;
    } catch (error) {
      console.error(`Error obteniendo empleados sin remuneración para proyecto ${proyectoId}:`, error);
      throw error;
    }
  },

  /**
   * Desactiva la remuneración de un empleado
   */
  deleteRemuneracion: async (empleadoId) => {
    try {
      const res = await pythonApiClient.delete(`${baseUrl}/${empleadoId}`);
      return res.data;
    } catch (error) {
      console.error('Error al desactivar remuneración:', error);
      throw error;
    }
  },

  /**
   * Obtiene parametría de RRHH
   */
  getParametria: async (codigo) => {
    try {
      const res = await pythonApiClient.get(`/rrhh/parametria/${codigo}`);
      return res.data;
    } catch (error) {
      console.error(`Error al obtener parametria ${codigo}:`, error);
      throw error;
    }
  }
};

export default remuneracionesApi;
